import { render } from "./ParcelCharts.vue?vue&type=template&id=834bdfd8&scoped=true&ts=true"
import script from "./ParcelCharts.vue?vue&type=script&lang=ts"
export * from "./ParcelCharts.vue?vue&type=script&lang=ts"

import "./ParcelCharts.vue?vue&type=style&index=0&id=834bdfd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-834bdfd8"]])

export default __exports__